<template>
  <div class="custom-breadcrumb secondaryFont">
    <router-link v-if="breadcrumbHome" :to="breadcrumbHome.to" class="breadcrumb-item home">
      <MonitorPause :size="16" />
    </router-link>
    <div v-for="(item, index) in breadcrumbItems" :key="index" class="flex align-items-center">
      <span class="breadcrumb-separator">
        <i class="pi pi-angle-right"></i>
      </span>
      <router-link v-if="index < breadcrumbItems.length - 1" :to="item.to" class="breadcrumb-item">
        {{ item.label }}
      </router-link>
      <span v-else class="breadcrumb-item current">
        {{ item.label }}
      </span>
    </div>
  </div>
</template>

<script>
import { useBreadcrumbStore } from "@/store/Pinia/useBreadcrumbStore";
import { MonitorPause } from "lucide-vue";

export default {
  name: "CustomBreadcrumb",
  components: {
    MonitorPause,
  },
  computed: {
    breadcrumbItems() {
      const breadcrumbStore = useBreadcrumbStore();
      return breadcrumbStore.items;
    },
    breadcrumbHome() {
      const breadcrumbStore = useBreadcrumbStore();
      return breadcrumbStore.home;
    },
  },
};
</script>

<style scoped>
.custom-breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  font-size: 14px;
  color: #637381;
  width: 100%;
  margin-bottom: 12px;
  padding-left: 37px;
}

.breadcrumb-item {
  color: #637381;
  text-decoration: none;
  transition: color 0.2s;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}

.breadcrumb-item:hover {
  color: #111827;
}

.breadcrumb-item.home {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.breadcrumb-item.current {
  color: #111827;
  font-weight: 500;
}

.breadcrumb-separator {
  color: #d1d5db;
  font-size: 12px;
  display: flex;
  align-items: center;
}
</style>
